"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkCell = exports.LinkCellContainer = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const style_1 = __importDefault(require("style"));
const Link_1 = require("../Link");
exports.LinkCellContainer = styled_components_1.default.span `
  ${style_1.default.Text.Definition.Truncate};
`;
const LinkCell = ({ path, value, }) => {
    return ((0, jsx_runtime_1.jsx)(exports.LinkCellContainer, { children: (0, jsx_runtime_1.jsx)(Link_1.Link, Object.assign({ path: path }, { children: value })) }));
};
exports.LinkCell = LinkCell;
